import React from "react";

const TopNavbarItem = props => {
  const { name, active, disabled, completed, action } = props;
  let itemClasses = "top-navbar-item";
  if (active) {
    itemClasses += " active";
  }
  if (disabled) {
    itemClasses += " disabled";
  }
  if (completed) {
    itemClasses += " completed";
  }
  return (
    <div className={itemClasses} onClick={() => action()}>
      <div className="top-navbar-item-text">{name.toUpperCase()}</div>
    </div>
  );
};

export default TopNavbarItem;
